export default {
  path: '/wecode/solution-detail',
  auth: false,
  preload: false,
  key: 'new-hardware-detail',
  component: () => import('./index')
};
